import { render } from "./SignupHome.vue?vue&type=template&id=30285104&scoped=true"
import script from "./SignupHome.vue?vue&type=script&lang=js"
export * from "./SignupHome.vue?vue&type=script&lang=js"

import "./SignupHome.vue?vue&type=style&index=0&id=30285104&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30285104"]])

export default __exports__